module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic12.fc6f1ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic12.png
// module id = 563
// module chunks = 1